/**
 * Единый реестр ссылок на документацию.
 * Все ссылки ведут на /docs/... (относительные пути).
 */
const doc_links = {
  customFormIntegration: '/docs/kak-nastroit-otpravku-dannykh-so-svoei-formy-registracii',
  receptionLogin: '/docs/offlain-registraciya/kak-zaiti-na-stoiku-registracii',
  chatBot: '/docs/chat-bot/kak-podklyuchit-chat-bota',
};

export default doc_links;
